import React, { Component } from 'react'
import { Link } from 'react-router'

import classNames from './ChannelTabs.css'
import TimezonePicker from '../TimezonePicker'
import { pluralize } from '../../utils/string'

export default class ChannelTabs extends Component {
  state = {
    openTab: null
  }
  toggleSchedule = () => {
    this.setState({
      openTab: this.state.openTab === 'schedule' ? null : 'schedule'
    })
  }
  toggleTimezone = () => {
    this.setState({
      openTab: this.state.openTab === 'timezone' ? null : 'timezone'
    })
  }
  renderSchedulePanel (data) {
    const { updateData } = this.props
    const timeUpdater = key => e => {
      const value = e.target.value
      if (value === data[key]) return
      if (e.target.value && /^\d\d:\d\d$/.test(e.target.value) === false) return
      updateData(key, e.target.value || null)
    }
    return (
      <div className={classNames.panel}>
        <div className={classNames.flex}>
          Schedule / View Period
          <input
            type='text'
            defaultValue={data.schedule_from}
            onBlur={timeUpdater('schedule_from')}
            placeholder='hh:mm'
            className={classNames.scheduleInput}
          />
          {' to '}
          <input
            type='text'
            defaultValue={data.schedule_to}
            onBlur={timeUpdater('schedule_to')}
            placeholder='hh:mm'
            className={classNames.scheduleInput}
          />
          (optional)
        </div>
        <label>
          <input
            type='checkbox'
            checked={data.schedule_reset}
            onChange={() => updateData('schedule_reset', !data.schedule_reset)}
          />
          Reset the queue when schedule starts
        </label>
        <label>
          <input
            type='checkbox'
            checked={data.schedule_force}
            onChange={() => updateData('schedule_force', !data.schedule_force)}
          />
          Play at any time within this view period
        </label>
      </div>
    )
  }
  renderTimezonePanel (data) {
    const { updateData } = this.props
    return (
      <div className={classNames.panel}>
        <TimezonePicker
          value={data.time_offset}
          onChange={e => updateData('time_offset', e.target.value)}
          label=''
        />
      </div>
    )
  }
  render () {
    const { channel, clients, mine, onClickShare } = this.props
    const { openTab } = this.state
    const data = channel.data || {}
    const shareCount = channel.members ? channel.members.length : 0
    if (!mine) {
      return (
        <Link to={`/present/${channel.id}`} className={classNames.fullWidthTab}>
          View
        </Link>
      )
    }
    return (
      <div className={classNames.tabs}>
        <Link to={`/present/${channel.id}`} className={classNames.tab}>
          View
          {clients.length !== 0 &&
            <span onClick={onClickShare} className={classNames.bubbleButton} title={`${pluralize(shareCount, 'person', 'people')} currently viewing this channel`}>
              {clients.length}
            </span>
          }
        </Link>
        <button className={classNames.tab} onClick={onClickShare}>
          Share
          {channel.disabled && ' disabled'}
          {!channel.disabled && shareCount !== 0 &&
            <span className={classNames.bubble} title={`Shared with ${pluralize(shareCount, 'person', 'people')}`}>
              {shareCount}
            </span>
          }
        </button>
        <button className={openTab === 'schedule' ? classNames.openTab : classNames.tab} onClick={this.toggleSchedule}>
          {getScheduleLabel(data.schedule_from, data.schedule_to)}
        </button>
        <button className={openTab === 'timezone' ? classNames.openTab : classNames.tab} onClick={this.toggleTimezone}>
          {getTimezoneLabel(parseInt(data.time_offset))}
        </button>
        {openTab === 'schedule' &&
          this.renderSchedulePanel(data)
        }
        {openTab === 'timezone' &&
          this.renderTimezonePanel(data)
        }
      </div>
    )
  }
}

function getScheduleLabel (start, end) {
  if (start && end) {
    return [start, <span key=''> to </span>, end]
  }
  if (start && !end) {
    return `Starts ${start}`
  }
  return 'Schedule'
}

function getTimezoneLabel (offset) {
  if (offset === 'device' || offset === 'default') {
    return 'Timezone'
  }
  if (!offset) {
    return 'GMT'
  }
  const sign = offset > 0 ? '+' : '-'
  const hours = Math.abs(offset) / 60 / 60
  return `GMT${sign}${hours}`
}



// WEBPACK FOOTER //
// ./src/components/channels/ChannelTabs.js